//Photographdetails
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getMethod, } from '../../services/apiService';
import { IMG_URL } from '../../utility/config';
import LoadingSpinner from '../../utility/LoadingSpinner';
import { toast } from 'react-toastify';

function Photographdetails() {
  const { id } = useParams();
  const [photographies, setPhotographies] = useState([]);
  const [category, setCategoryTitle] = useState([]);
  const [categoryDescription, setCategoryDescription] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const IMG_BASE_URL = IMG_URL

  //Display PhotographList - GET
  useEffect(() => {
    const fetchData = async () => {
      const response = await getMethod('photography-categories');
      console.log("=======overallDesc", response)
      if (!response.error && Array.isArray(response.category?.data)) {
        const data = response.category.data.map(item => ({
          id: item.id,
          title: item.name,
          common_description: item.common_description,
        }));
        const current = data.find(cat => String(cat.id) === String(id));
        if (current) {
          setCategoryTitle(current.title);
          setCategoryDescription(current.common_description)
        }
        setLoading(false)
      } else {
        console.error("Error fetching paintings", response);
        setCategoryTitle([]);
      }
    };

    fetchData();
  }, [])

  //Get by category-ID for photographies(groups)
  useEffect(() => {
    const fetchPhotographies = async () => {
      if (!id) return;

      const response = await getMethod(`photographies/by-category/${id}`);
      console.log("Photographies response:", response);

      if (!response.error && response.data) {
        setPhotographies(response.data);
        setError(null);
      } else {
        setError(response.error || 'Failed to fetch photographies');
        toast.error(response.error || 'Failed to fetch photographies');
      }

      setLoading(false);
    };

    fetchPhotographies();
  }, [id]);


  if (loading) return <LoadingSpinner />;

  const isEmptyHTML = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent.trim() === '';
  };

  return (
    <div className="photograph_details_wholediv">
      <h2 className="photograph_details_title" dangerouslySetInnerHTML={{ __html: category || 'Category' }} />
      <div className="photograph_details_div">
        {photographies.map((detail) => (
          <div key={detail.id}>
            <img className='photographdetails_card_img'
              src={`${IMG_BASE_URL}/${detail.image_url}`}
              alt={detail.title}
            />
            {/* <p className='photographdetails_card_p' dangerouslySetInnerHTML={{ __html: detail.description }} /> */}

            {detail.description && !isEmptyHTML(detail.description) ? (
              <p
                className='photographdetails_card_p'
                dangerouslySetInnerHTML={{ __html: detail.description }}
              />
            ) : null}

          </div>
        ))}
      </div>
      <div dangerouslySetInnerHTML={{ __html: categoryDescription }} />
    </div>
  );
}

export default Photographdetails;
